import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { API_BASE_URL, CLOUDFRONT_STATIC_URL, CRYPTO_SECRET_KEY, capitalizeFirstLetter } from "src/_config";
import { toPng } from "html-to-image";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppLoader } from "src/_common/hooks/actions/common/appLoaderHook";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import { camelCase } from "lodash";
import { useParams } from "react-router";
import { useAppEventGameListSelector } from "src/_common/hooks/selectors/eventSelector";

interface PickedTeamModalProps {
  onClose: (success: any) => void;
  shouldShow: boolean;
  teamDetails: any;
  performanceDetails?: any;
  openShareModal?: (url: any) => void;
  setPerformanceDetails?: any;
  tieBreakerCode?: any;
}

export default function PickedTeamModal({
  onClose,
  shouldShow,
  teamDetails,
  performanceDetails,
  setPerformanceDetails,
  tieBreakerCode,
  openShareModal,
}: PickedTeamModalProps) {
  const eventApi = useEventApi();
  const elementRef = useRef<any>(null);
  const loader = useAppLoader();
  const userDetails = useAppUserDetailsSelector();
  const eventGameListSelector = useAppEventGameListSelector();

  const htmlToImageConvert = () => {
    // if(setPerformanceDetails && eventGameListSelector) {
    //     setPerformanceDetails(eventGameListSelector[0].performance_dtls)
    // }
    loader.showLoader();
    if (!performanceDetails && eventGameListSelector) {
      let c = document.getElementById("congratsImgSection");
      if (c) {
        c.style.textAlign = "center";
        c.innerHTML =
          "<h2 className='rider-name-content text-center pt-2'><strong id='userTeamTitle'>" +
          capitalizeFirstLetter(eventGameListSelector[0].performance_dtls?.title) +
          "</strong></h2>";
      }
      let tb = document.getElementById("tieBreakerCode");
      if (tb) {
        tb.style.display = "none";
      }
    }
    let x = document.getElementById("userTeamTitle");
    console.log({ x });
    if (x) {
      let text = x.innerText;
      x.innerText =
        (userDetails?.display_name || userDetails?.first_name
          ? (userDetails?.display_name || (userDetails?.first_name && camelCase(userDetails?.first_name + ""))) + "'s "
          : "") +
        text +
        " Team";
      x.style.wordBreak = "break-word";
      x.style.fontSize = "16px";
      x.style.textAlign = "center";
    }
    let y: any = document.getElementsByClassName("team-ul");
    console.log({ y });
    if (y) {
      y[0].style.width = "100vw";
      y[0].style.fontSize = "13px";
      y[0].style.maxWidth = "90%";
      y[0].style.display = "inline-block";
      y[0].style.wordBreak = "break-word";
      y[0].style.whiteSpace = "normal";
      y[0].style.padding = "25px";
    }
    toPng(elementRef.current, { cacheBust: false })
      .then((dataUrl: any) => {
        // const link = document.createElement("a");
        // link.download = "my-image-name.png";
        // link.href = dataUrl;
        console.log({ dataUrl });
        let fd = new FormData();
        fd.append("share_image", dataUrl);
        eventApi.callGetShareImageLink(
          fd,
          (message: any, resp: any) => {
            // console.log({resp})
            if (resp?.file_link && openShareModal) {
              // let link = window.location.origin + "/team/" + resp?.file_link.substring(resp?.file_link.lastIndexOf('/')+1,resp?.file_link.lastIndexOf('.'))
              // let link = API_BASE_URL.substring(0,API_BASE_URL.indexOf('/api')) + "/share.php?" + resp?.file_link.substring(resp?.file_link.lastIndexOf('/')+1,resp?.file_link.lastIndexOf('.'))
              let link =
                window.location.origin +
                "/share.php?" +
                resp?.file_link.substring(resp?.file_link.lastIndexOf("/") + 1, resp?.file_link.lastIndexOf("."));
              console.log({ link });
              openShareModal(link);
              loader.hideLoader();
            }
          },
          (message: any, resp: any) => {
            loader.hideLoader();
          }
        );
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  useEffect(() => {
    // console.log({performanceDetails})
  }, [performanceDetails]);

  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Body>
          <div
            className="modal-body"
            style={{ backgroundColor: "#d7b270", width: "100%", fontFamily: "Gotham-Book" }}
            ref={elementRef}
          >
            {!performanceDetails ? (
              <>
                <div id="congratsImgSection">
                  <img src={"/images/ENTERED.jpg"} style={{ width: "100%" }} />
                  <h4 className="rider-name-content text-center pt-2">
                    <strong>Congratulations! Your Rodeo Picks are in!!!</strong>
                  </h4>
                </div>
                {tieBreakerCode && (
                  <p style={{ fontSize: 20, fontWeight: 700, textAlign: "center" }} id="tieBreakerCode">
                    {`(Your Tie Breaker Code: ${tieBreakerCode})`}
                  </p>
                )}
              </>
            ) : (
              <h2 className="rider-name-content text-center pt-2">
                <strong id="userTeamTitle">{capitalizeFirstLetter(performanceDetails?.title)}</strong>
              </h2>
            )}
            <ul className="team-ul">
              {teamDetails?.length
                ? teamDetails?.map((team: any, i: any) => (
                    <li key={i} className="team-li pt-2 d-flex justify-content-between">
                      <span>
                        <b>{team.event_name}</b> - {performanceDetails ? team?.name || "Not picked" : team.rider}
                      </span>
                      {team?.is_winner ? (
                        <i
                          className="fa fa-check-circle"
                          style={{ fontSize: "15px", color: "green", paddingLeft: "3px" }}
                        />
                      ) : null}
                    </li>
                  ))
                : null}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={htmlToImageConvert}>
              Share
            </button>
            <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={onClose}>
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
